import { render, staticRenderFns } from "./DashboardStats.vue?vue&type=template&id=0cbbc8da&scoped=true"
import script from "./DashboardStats.vue?vue&type=script&lang=js"
export * from "./DashboardStats.vue?vue&type=script&lang=js"
import style0 from "./DashboardStats.vue?vue&type=style&index=0&id=0cbbc8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbc8da",
  null
  
)

export default component.exports